export default __webpack_public_path__ + "static/media/top-b-3-thumb.eace7308.jpg";